import { getQueryParam } from '../shared/utils.js';
import { elements } from './elements.js';
import { expandFilterMenu } from '../../../includes/collapseFilterGroup.js';
import { hiddenClass } from '../../../config.js';
import Choices from 'choices.js';

export const preloadFormFields = () => {
    const { searchInput, yearSelect, fundingTypeSelect, clearSearchButton, searchButton } = elements;

    if (searchInput) {
        searchInput.value = getQueryParam('q') || '';
        searchInput.placeholder = window.screen.width >= 768 ? 'Search by project title or key people' : 'Search';

        // If the search input is not empty, show the clear button and hide the search icon
        if (clearSearchButton && searchButton && searchInput.value !== '') {
            clearSearchButton.classList.remove(hiddenClass);
            searchButton.classList.add(hiddenClass);
        }
    }
    const allChoices = {};
    if (yearSelect) {
        yearSelect.value = getQueryParam('year') || '';
        const choices = new Choices(yearSelect, {
            searchEnabled: false
        });
        allChoices[yearSelect.name] = choices;
    }
    if (fundingTypeSelect) {
        fundingTypeSelect.value = getQueryParam('type') || '';
        const choices = new Choices(fundingTypeSelect, {
            searchEnabled: false
        });
        allChoices[fundingTypeSelect.name] = choices;
    }

    if (yearSelect?.value || fundingTypeSelect?.value) {
        expandFilterMenu(elements.expandableFilter);
    }

    return { allChoices };
};
